// Product page urgency lines, worked out in the visitor's browser:
// - dispatch date: [data-delivery-date]
// - daily order deadline: [data-cutoff-countdown]
// - sale countdown: [data-sale-countdown]
(function () {
  if (window.productUrgencyLoaded) return;
  window.productUrgencyLoaded = true;

  const MINUTE = 60 * 1000;

  function isWeekend(date) {
    return date.getDay() === 0 || date.getDay() === 6;
  }

  function moveOffWeekend(date) {
    if (date.getDay() === 6) date.setDate(date.getDate() + 2);
    if (date.getDay() === 0) date.setDate(date.getDate() + 1);
    return date;
  }

  // The next weekday moment at the cut-off hour that hasn't passed yet
  function nextCutoff(now, cutoffHour) {
    const cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);
    while (cutoff <= now || isWeekend(cutoff)) {
      cutoff.setDate(cutoff.getDate() + 1);
    }
    return cutoff;
  }

  function dispatchDate(baseDay, handlingDays) {
    const date = new Date(baseDay);
    date.setDate(date.getDate() + handlingDays);
    return moveOffWeekend(date);
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat(document.documentElement.lang || 'pl', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
    }).format(date);
  }

  function formatDuration(ms, units) {
    const totalMinutes = Math.max(1, Math.ceil(ms / MINUTE));
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;

    if (days > 0) return `${days} ${days === 1 ? units.day : units.days} ${hours} ${units.hours}`;
    if (hours > 0) return `${hours} ${units.hours} ${minutes} ${units.minutes}`;
    return `${minutes} ${units.minutes}`;
  }

  function readUnits(el) {
    try {
      return JSON.parse(el.dataset.units);
    } catch (error) {
      return { day: 'dzień', days: 'dni', hours: 'godz.', minutes: 'min' };
    }
  }

  function update() {
    const now = new Date();

    document.querySelectorAll('[data-delivery-estimate]').forEach((box) => {
      const handlingDays = Number(box.dataset.handlingDays || 0);
      const cutoffHour = box.dataset.cutoffHour === '' ? null : Number(box.dataset.cutoffHour);
      const cutoff = cutoffHour === null ? null : nextCutoff(now, cutoffHour);
      const baseDay = cutoff || now;
      const shipOn = formatDate(dispatchDate(baseDay, handlingDays));

      box.querySelectorAll('[data-delivery-date]').forEach((el) => (el.textContent = shipOn));

      box.querySelectorAll('[data-cutoff-countdown]').forEach((el) => {
        if (!cutoff) return;
        const template = el.dataset.template || '';
        el.textContent = template
          .replace('{time}', formatDuration(cutoff - now, readUnits(el)))
          .replace('{date}', shipOn);
        el.closest('[data-cutoff-line]')?.removeAttribute('hidden');
      });
    });

    document.querySelectorAll('[data-sale-countdown]').forEach((el) => {
      const end = new Date(el.dataset.end);
      const line = el.closest('[data-sale-line]');
      if (Number.isNaN(end.getTime()) || end <= now) {
        line?.setAttribute('hidden', '');
        return;
      }
      el.textContent = formatDuration(end - now, readUnits(el));
      line?.removeAttribute('hidden');
    });
  }

  function start() {
    update();
    setInterval(update, MINUTE);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', update);
})();
